// import AreaMeasurement2D from "@arcgis/core/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel";
import DistanceMeasurement2D from "@arcgis/core/widgets/DistanceMeasurement2D";
export async function Measurement(settings) {
    let measurementObject = [];
    let measurementWidget = new DistanceMeasurement2D({
        view: settings.view
    });
    settings.view.ui.add(measurementWidget, settings.widgetPosition);
    measurementWidget.watch("viewModel.measurement", function (measurement) {
        // console.log(
        //     "Length: ", measurement.length,
        //     "Geometry: ", measurement.geometry
        // );
        measurementObject.push({
            length: measurement.length,
            geometry: measurement.geometry
        });
    });
    measurementWidget.watch("viewModel.measurementLabel", function (label) {
        // console.log(
        //     "Label: ", label
        // );
        measurementObject.push({
            label: label
        });
    });
    return measurementObject;
}
